import { useNavigate, useParams } from 'react-router-dom';
import { Section } from '@plush-book/ui';
import { StatusBadge } from '../components/StatusBadge';
import { RiskBadge } from '../components/RiskBadge';

export function DetailView() {
  const nav = useNavigate();
  const { id } = useParams();
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        background: 'var(--a-bg)',
      }}
    >
      <div
        style={{
          padding: '14px 24px',
          borderBottom: '1px solid var(--a-line)',
          background: 'var(--a-card)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div
            style={{ fontSize: 11, color: 'var(--a-ink-mute)', display: 'flex', gap: 6, alignItems: 'center' }}
          >
            <span
              onClick={() => nav('/')}
              style={{ cursor: 'pointer', color: 'var(--a-blue)' }}
            >
              Bücher
            </span>{' '}
            /{' '}
            <span style={{ fontFamily: 'var(--mono)', color: 'var(--a-ink-soft)' }}>{id}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 2 }}>
            <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0, color: 'var(--a-ink)' }}>
              Brunos Buch — Anna Weber
            </h1>
            <StatusBadge status="Needs Review" />
            <RiskBadge level="low" />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn('outline')}>Send Review Link</button>
          <button style={btn('outline')}>Export Preview PDF</button>
          <button style={btn('green')}>✓ Mark Approved</button>
        </div>
      </div>

      <div
        style={{
          flex: 1,
          overflow: 'auto',
          padding: 18,
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) 320px',
          gap: 18,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Section
            title="Generated Pages"
            right={
              <span style={{ fontSize: 11, color: 'var(--a-ink-mute)' }}>
                16 Seiten · 12 ready · 2 generating · 2 pending
              </span>
            }
          >
            <PagesGrid />
          </Section>
          <Section title="Plush Toy Uploads" right={<RiskBadge level="low" />}>
            <PlushUploads />
          </Section>
          <Section
            title="Revision Requests"
            right={
              <span style={{ fontSize: 11, color: 'var(--a-ink-mute)' }}>
                0 offen · 0 abgeschlossen
              </span>
            }
          >
            <div
              style={{
                padding: 14,
                fontSize: 12,
                color: 'var(--a-ink-mute)',
                textAlign: 'center',
              }}
            >
              Noch keine Korrekturwünsche. Wenn der Kunde eine Korrektur anfragt, erscheinen hier
              Nachricht, Kategorie und betroffene Seite.
            </div>
          </Section>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Section title="Customer">
            <div style={{ padding: 14, fontSize: 12 }}>
              <KV k="E-Mail" v="anna.weber@gmail.com" />
              <KV k="Name" v="Anna Weber" />
              <KV k="Land" v="DE" />
              <KV k="Erste Bestellung" v="Ja" />
            </div>
          </Section>
          <Section title="Shopify Order">
            <div style={{ padding: 14, fontSize: 12 }}>
              <KV
                k="Order"
                v={
                  <a style={{ color: 'var(--a-blue)', fontFamily: 'var(--mono)' }}>#1942 ↗</a>
                }
              />
              <KV k="Total" v="29,90 €" />
              <KV k="Bezahlt am" v="06.05.2026 09:14" />
              <KV k="Versand" v="DHL Standard" />
            </div>
          </Section>
          <Section title="Story Template">
            <div style={{ padding: 14, fontSize: 12 }}>
              <KV k="Vorlage" v="sleep_star" mono />
              <KV k="Titel" v="Der verlorene Schlafstern" />
              <KV k="Seiten" v="16" />
              <KV k="Bilder" v="7" />
            </div>
          </Section>
          <Section title="Print Status">
            <div style={{ padding: 14 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[
                  { l: 'PDF generiert', d: true },
                  { l: 'An Druckerei gesendet', d: false },
                  { l: 'In Produktion', d: false },
                  { l: 'Versendet', d: false },
                ].map((s, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      gap: 10,
                      fontSize: 12,
                      color: s.d ? 'var(--a-ink)' : 'var(--a-ink-mute)',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: 999,
                        background: s.d ? 'var(--a-green)' : 'var(--a-line)',
                        color: '#fff',
                        display: 'grid',
                        placeItems: 'center',
                        fontSize: 10,
                      }}
                    >
                      {s.d ? '✓' : ''}
                    </span>
                    {s.l}
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: 6, marginTop: 12 }}>
                <button style={{ ...btn('outline'), flex: 1 }}>Mark Sent</button>
                <button style={{ ...btn('outline'), flex: 1 }}>Mark Shipped</button>
              </div>
            </div>
          </Section>
          <Section title="Internal Notes">
            <div style={{ padding: 14 }}>
              <textarea
                defaultValue="06.05. — Cover sieht gut aus, IP unbedenklich. Print PDF nach finaler Freigabe exportieren."
                style={{
                  width: '100%',
                  padding: 10,
                  fontSize: 12,
                  border: '1px solid var(--a-line)',
                  borderRadius: 5,
                  fontFamily: 'var(--sans)',
                  color: 'var(--a-ink-soft)',
                  resize: 'none',
                  minHeight: 80,
                  boxSizing: 'border-box',
                  background: '#FFFCEF',
                  outline: 'none',
                }}
              />
            </div>
          </Section>
        </div>
      </div>
    </div>
  );
}

function PagesGrid() {
  const layouts = [
    'cover_full',
    'text_center',
    'image_top_text_bottom',
    'text_only',
    'image_full_bleed',
    'image_top_text_bottom',
    'text_only',
    'image_full_bleed',
  ];
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 10,
        padding: 14,
      }}
    >
      {Array.from({ length: 8 }).map((_, i) => {
        const status = i < 6 ? 'ready' : i === 6 ? 'generating' : 'pending';
        const sCol =
          status === 'ready'
            ? 'var(--a-green)'
            : status === 'generating'
              ? 'var(--a-amber)'
              : 'var(--a-ink-mute)';
        const bg =
          i === 0
            ? 'linear-gradient(160deg, #DCE7EE, #A8C0D2)'
            : i % 3 === 1
              ? 'var(--a-card)'
              : i % 3 === 2
                ? 'linear-gradient(160deg, #2C3E54, #4D6781)'
                : 'linear-gradient(160deg, #F4E5C4, #E0CC9D)';
        return (
          <div
            key={i}
            style={{
              border: '1px solid var(--a-line)',
              borderRadius: 8,
              overflow: 'hidden',
              background: 'var(--a-card)',
            }}
          >
            <div style={{ aspectRatio: '3/4', background: bg, position: 'relative' }}>
              <div
                style={{
                  position: 'absolute',
                  left: 6,
                  top: 6,
                  fontSize: 10,
                  fontFamily: 'var(--mono)',
                  color: i === 0 || i % 3 === 2 ? 'rgba(255,255,255,0.7)' : 'var(--a-ink-mute)',
                }}
              >
                S.{String(i + 1).padStart(2, '0')}
              </div>
              <div
                style={{
                  position: 'absolute',
                  right: 6,
                  top: 6,
                  padding: '1px 5px',
                  background: 'rgba(255,255,255,0.9)',
                  borderRadius: 3,
                  fontSize: 9,
                  color: sCol,
                  fontWeight: 700,
                }}
              >
                {status.toUpperCase()}
              </div>
            </div>
            <div style={{ padding: '8px 10px' }}>
              <div style={{ fontSize: 10, color: 'var(--a-ink-mute)', fontFamily: 'var(--mono)' }}>
                {layouts[i]}
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: 'var(--a-ink-soft)',
                  marginTop: 2,
                  lineHeight: 1.35,
                  height: 28,
                  overflow: 'hidden',
                }}
              >
                {i === 0
                  ? 'Bruno & der Schlafstern'
                  : i === 1
                    ? 'Für Carlo — weil Bruno…'
                    : 'Als es im Kinderzimmer leise wurde, öffnete Bruno…'}
              </div>
              <div style={{ display: 'flex', gap: 4, marginTop: 8 }}>
                <button style={miniBtn}>↻ Bild</button>
                <button style={miniBtn}>✎ Text</button>
                <button
                  style={{
                    ...miniBtn,
                    background: 'var(--a-green-soft)',
                    color: 'var(--a-green)',
                    fontWeight: 700,
                    border: 0,
                    flex: 0,
                  }}
                >
                  ✓
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function PlushUploads() {
  return (
    <div style={{ padding: 14 }}>
      <div style={{ display: 'flex', gap: 14, alignItems: 'start' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 64px)', gap: 6 }}>
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="plush-placeholder"
              style={{
                width: 64,
                height: 64,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #C8916A, #8E5B3E)',
                color: 'rgba(255,255,255,0.7)',
                fontSize: 8,
              }}
            >
              {['VORNE', 'SEITE', 'KOMPLETT'][i]}
            </div>
          ))}
        </div>
        <div
          style={{
            flex: 1,
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 12,
            fontSize: 12,
          }}
        >
          <KV k="Name" v="Bruno" />
          <KV k="Art" v="Bär" />
          <KV k="Pronomen" v="er" />
          <KV k="Eigenschaft" v="tapfer" />
          <KV k="IP Risk" v={<RiskBadge level="low" />} />
          <KV k="Confidence" v="0.12" mono />
        </div>
      </div>
      <div
        style={{
          marginTop: 14,
          padding: 12,
          background: 'var(--a-bg)',
          borderRadius: 6,
          fontSize: 11,
          lineHeight: 1.55,
          color: 'var(--a-ink-soft)',
        }}
      >
        <div style={{ fontWeight: 700, color: 'var(--a-ink)', marginBottom: 4 }}>
          Vision Description
        </div>
        Brown plush bear, soft fabric texture, large dark eyes, slightly worn, cream-colored
        muzzle, ears with rounded tips. No visible logos or branded markings.
      </div>
      <div style={{ marginTop: 12, display: 'flex', gap: 6 }}>
        <button
          style={{
            padding: '6px 12px',
            borderRadius: 5,
            fontSize: 11,
            fontWeight: 600,
            background: 'var(--a-green-soft)',
            color: 'var(--a-green)',
            border: 0,
            cursor: 'pointer',
          }}
        >
          ✓ Approve IP Check
        </button>
        <button style={btn('outline')}>Request New Plushie</button>
        <button style={{ ...btn('outline'), color: 'var(--a-red)' }}>Reject Upload</button>
      </div>
    </div>
  );
}

function KV({ k, v, mono }: { k: string; v: React.ReactNode; mono?: boolean }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '5px 0',
        borderBottom: '1px dashed var(--a-line-soft)',
      }}
    >
      <span style={{ color: 'var(--a-ink-mute)', fontSize: 11 }}>{k}</span>
      <span
        style={{
          color: 'var(--a-ink)',
          fontWeight: 600,
          fontSize: 12,
          fontFamily: mono ? 'var(--mono)' : 'var(--sans)',
        }}
      >
        {v}
      </span>
    </div>
  );
}

const miniBtn: React.CSSProperties = {
  flex: 1,
  padding: '4px',
  fontSize: 10,
  border: '1px solid var(--a-line)',
  borderRadius: 4,
  background: 'var(--a-card)',
  color: 'var(--a-ink-soft)',
  fontWeight: 600,
  cursor: 'pointer',
};

function btn(kind: 'outline' | 'green'): React.CSSProperties {
  if (kind === 'green') {
    return {
      padding: '8px 14px',
      borderRadius: 6,
      fontSize: 12,
      fontWeight: 600,
      background: 'var(--a-green)',
      color: '#fff',
      border: 0,
      cursor: 'pointer',
    };
  }
  return {
    padding: '8px 14px',
    border: '1px solid var(--a-line)',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    background: 'var(--a-card)',
    color: 'var(--a-ink-soft)',
    cursor: 'pointer',
  };
}
